module.exports = __webpack_public_path__ + "img/bth_internet.b0fb1fbc.png";